import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function IntegrationSalesforceRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.IntegrationSalesforce', {
		url: '/admin/integrations/salesforce',
		controllerAs: 'vm',
		controller: IntegrationSalesforceCtrl,
		templateUrl: '/ng/hub/Integration/Salesforce/IntegrationSalesforceCtrl.html?' + window.BUILD,
		permission: ['standard_intel'],
		resolve: {
			$title: () => 'Salesforce Embeds',
			embeds: ApiResourcify.endpoint('/embed_configs'),
		},
	});
}

export class IntegrationSalesforceCtrl {
	constructor() {
		'ngInject';
		this.templateString = `<apex:page docType="html-5.0" standardController="{standardController}">
  <apex:iframe
    src="{url}?sso={sso}&term={term}"
    scrolling="true"
    height="{height}px"
    width="{width}px"
  />
</apex:page>`;
	}
}
